import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Profilo } from 'src/app/interfaces/user';
import { displayOperation } from 'src/app/utilities/utilities';

@Component({
  selector: 'sanremo-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.css']
})
export class DropdownMenuComponent implements OnInit {

	@Input() profilo : Profilo;
	@Input() isCollapsed;
	@Output() changeCollapse = new EventEmitter();

	constructor() { }

	ngOnInit() { }

	showJurorRegistrationPage() : boolean {
    return displayOperation(['ReadAllJurorResources', 'GetNationsFromAuthConf', 'GetJurorInfo', 'JurorRegistration'], this.profilo.Funzionalita);
	}

	showUserRegistrationPage() : boolean {
		return displayOperation(['GetNationsFromAuthConf', 'GetValidationsFromAuthConf', 'GetDocumentTypesFromAuthConf', 'ExternalUserRegistration'], this.profilo.Funzionalita);
  }
  
  showRecordCompanyRegistrationPage() : boolean {
		return displayOperation(['GetValidationsFromAuthConf', 'GetNationsFromAuthConf', 'RecordCompanyRegistration'], this.profilo.Funzionalita);
	}

	showRecordCompanyWithRLRegistrationPage() : boolean {
		return displayOperation(['GetValidationsFromAuthConf', 'GetNationsFromAuthConf', 'GetDocumentTypesFromAuthConf', 'RecordCompanyUserRegistration'], this.profilo.Funzionalita);
	}

	change(){
		this.isCollapsed = !this.isCollapsed;
		this.changeCollapse.emit(this.isCollapsed);
	}
}
